import moment from 'moment-timezone';

export const getTimezone = ({ prefix = 'GMT', currentAccount, tzLabel = null }) => {
    const tz = tzLabel ?? currentAccount?.settings?.timeZoneDashboard ?? currentAccount?.timeZone;
    const dstCorrection = currentAccount?.dstCorrection;

    const zone = moment.tz.zone(tz);
    if (!zone) return prefix ? `(${prefix}) ${tz}` : 0;

    // Get offset based on DST correction setting
    const referenceTime = dstCorrection
        ? moment.utc() // Current time (includes DST)
        : moment.utc().startOf('year'); // Standard time (ignores DST)

    const offset = -zone.utcOffset(referenceTime);

    if (!prefix) {
        return offset / 60;
    }

    const sign = offset >= 0 ? '+' : '-';
    const abs = Math.abs(offset);
    const hh = String(Math.floor(abs / 60)).padStart(2, '0');
    const mm = String(abs % 60).padStart(2, '0');
    return `(${prefix}${sign}${hh}:${mm})`;
};
